import { observable } from 'mobx';

export type TravelerNameChangeResponseArgs = {
  original_traveler_name: string | null;
  current_traveler_name: string | null;
  traveler_name_changed: boolean;
};

export type TravelerNameChangeArgs = {
  originalTravelerName: string | null;
  currentTravelerName: string | null;
  travelerNameChanged: boolean;
};

export const convertTravelerNameChangeResponseToArgs = (
  response: TravelerNameChangeResponseArgs
): TravelerNameChangeArgs => {
  return {
    originalTravelerName: response.original_traveler_name,
    currentTravelerName: response.current_traveler_name,
    travelerNameChanged: response.traveler_name_changed
  };
};

export default class TravelerNameChange {
  @observable originalTravelerName: string | null;
  @observable currentTravelerName: string | null;
  @observable travelerNameChanged: boolean;

  constructor(args: TravelerNameChangeArgs) {
    this.originalTravelerName = args.originalTravelerName;
    this.currentTravelerName = args.currentTravelerName;
    this.travelerNameChanged = args.travelerNameChanged;
  }
}
